<div [ngClass]="{ 'show-outline': showOutline }">
  <router-outlet></router-outlet>
</div>
